"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var styles_less_1 = __importDefault(require("./styles.less"));
var ModalX = function (_a) {
    var isOpen = _a.isOpen, title = _a.title, subtitle = _a.subtitle, onClose = _a.onClose, _b = _a.size, size = _b === void 0 ? 'xl' : _b, children = _a.children, headerExtras = _a.headerExtras, className = _a.className;
    react_1.default.useEffect(function () {
        if (!isOpen)
            return;
        var original = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return function () {
            document.body.style.overflow = original;
        };
    }, [isOpen]);
    if (!isOpen)
        return null;
    return (react_1.default.createElement("div", { className: styles_less_1.default['mx-root'], role: "dialog", "aria-modal": "true" },
        react_1.default.createElement("div", { className: styles_less_1.default['mx-backdrop'], onClick: onClose }),
        react_1.default.createElement("div", { className: (0, classnames_1.default)(styles_less_1.default['mx-dialog'], styles_less_1.default["mx-".concat(size)], className) },
            react_1.default.createElement("div", { className: styles_less_1.default['mx-header'] },
                react_1.default.createElement("div", { className: styles_less_1.default['mx-titles'] },
                    title ? react_1.default.createElement("div", { className: styles_less_1.default['mx-title'] }, title) : null,
                    subtitle ? react_1.default.createElement("div", { className: styles_less_1.default['mx-subtitle'] }, subtitle) : null),
                react_1.default.createElement("div", { className: styles_less_1.default['mx-actions'] },
                    headerExtras,
                    react_1.default.createElement("button", { className: styles_less_1.default['mx-close'], onClick: onClose, "aria-label": "Close" }, "\u2715"))),
            react_1.default.createElement("div", { className: styles_less_1.default['mx-body'] }, children))));
};
exports.default = ModalX;
